import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Web3 from "web3";
import { devCondoABI } from "../../../utils/constant/abi";
import { mapleABI } from "../../../utils/constant/abi";
import { brickkenABI } from "../../../utils/constant/abi";
import { indexCoopABI } from "../../../utils/constant/abi";
import { usdcABI } from "../../../utils/constant/abi";
import { polytradeABI } from "../../../utils/constant/abi";
import {
  fetchCoinDetail,
  fetchIndexCoopDetail,
} from "../../../utils/services/api";
import axios from "axios";
import * as API from "../../../utils/services/api";

import img2024 from "../../../assets/images/banner/2024.svg";
import BannerMiniCondo from "../../../assets/images/banner/bannerminicondo.svg";
import BannerMiniOndo from "../../../assets/images/banner/bannerminiondo.svg";
import CondoBannerLogo from "../../../assets/images/banner/condobannerlogo.svg";
import MovingCat from "../../../assets/images/about/moving-cat.gif";
import StillCats from "../../../assets/images/about/still-cats.png";
import ArrowSection2 from "../../../assets/images/about/arrow-section-2.svg";
import Pixelated from "../../../assets/images/about/pixelated-x.svg";
import NathanLaryFinal from "../../../assets/images/frames/nathan-lary-final.png";
import Coin from "../../../assets/images/buy-token/coin.gif";
import WalkingCat from "../../../assets/images/how-to-buy/how-to-buy-walking-cat.gif";
import TokenomicsBanner from "../../../assets/images/tokenomics/tokenomics-banner.svg";
import TokenomicsMobileBlue from "../../../assets/images/tokenomics/tokenomics-mobile-blue.svg";
import Tea from "../../../assets/images/tokenomics/tea.svg";
import Fan from "../../../assets/images/tokenomics/fan.svg";
import NathanImage2 from "../../../assets/images/banner/nathan-image-2.png";
import MusicBtn from "../../../assets/images/music-btn.svg";
import MuteBtn from "../../../assets/images/mute-btn.svg";
import HowToBuy from "../../../assets/images/how-to-buy/how-to-buy.png";
import DextoolWhite from "../../../assets/images/prepage/DEXTools_ white.png";
import CatTokeno from "../../../assets/images/tokenomics/cat-gif-tokeno.gif";
import Bumbershoot from "../../../assets/images/audio/Bumbershoot.mp3";
import { fetchCondo, fetchEth, fetchAurusX } from "../../../utils/services/api";
import { TreasuryContext } from "../../../context/TreasuryContextProvider";

const Home = () => {
  const condoABI = [
    {
      inputs: [
        { internalType: "address", name: "_uniswapV2Router", type: "address" },
        { internalType: "address", name: "_treasuryWallet", type: "address" },
        { internalType: "uint256", name: "_threshold", type: "uint256" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "allowance", type: "uint256" },
        { internalType: "uint256", name: "needed", type: "uint256" },
      ],
      name: "ERC20InsufficientAllowance",
      type: "error",
    },
    {
      inputs: [
        { internalType: "address", name: "sender", type: "address" },
        { internalType: "uint256", name: "balance", type: "uint256" },
        { internalType: "uint256", name: "needed", type: "uint256" },
      ],
      name: "ERC20InsufficientBalance",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "approver", type: "address" }],
      name: "ERC20InvalidApprover",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "receiver", type: "address" }],
      name: "ERC20InvalidReceiver",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "sender", type: "address" }],
      name: "ERC20InvalidSender",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "spender", type: "address" }],
      name: "ERC20InvalidSpender",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "owner", type: "address" }],
      name: "OwnableInvalidOwner",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "OwnableUnauthorizedAccount",
      type: "error",
    },
    { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "isExcluded",
          type: "bool",
        },
      ],
      name: "ExcludeFromFees",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "pair",
          type: "address",
        },
        { indexed: true, internalType: "bool", name: "value", type: "bool" },
      ],
      name: "SetAutomatedMarketMakerPair",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "allowance",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "approve",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "automatedMarketMakerPairs",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "buyFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "sellFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "transfer",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "treasuryWallet",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "uniswapV2Pair",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "uniswapV2Router",
      outputs: [
        {
          internalType: "contract IUniswapV2Router02",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];
  const condoAirdropAddress = "0x1aaed91A496d8D875A33820d09b2a68541Fb8B3D";
  const baseWalletAddress = "0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf";
  const polyAddressToCheck = "0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310";
  const mapleContract = "0x33349B282065b0284d756F0577FB39c158F935e6";
  const syrupContract = "0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66";
  const brickkenContract = "0x0e28bC9B03971E95acF9ae1326E51ecF9C55B498";
  const indexCoopContract = "0xC884646E6C88d9b172a23051b38B0732Cc3E35a6";
  const devAddress = "0xEf3E49a3197417ccDbF5F6A60D89f7Fa4823199d";
  const devCondoContract = "0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf";
  const usdcContract = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
  const isMobile = window.innerWidth < 600;
  const [totalBalance, setTotalBalance] = useState(null);
  const [totalCondo, setTotalCondo] = useState(null);
  const [totalMaple, setTotalMaple] = useState(null);
  const [totalCondo1, setTotatCondo1] = useState(null);
  const [totalBrickken, setTotalBrickken] = useState(null);
  const [condoBal, setCondoBal] = useState(null);
  const [ethBal, setEthBal] = useState(null);
  const [condoTrans, setCondoTrans] = useState(null);
  const [condoTrans2, setCondoTrans2] = useState(null);
  const [indexCoopBal, setIndexCoopBal] = useState(null);
  const [totalIndexCoop, setTotalIndexCoop] = useState(null);
  const [totalUSDC, setTotalUSDC] = useState(null);
  const [totalUSDCBal, setTotalUSDCBal] = useState(null);
  const [polyBal, setPolyBal] = useState(null);
  const [tradeBal, setTradeBal] = useState({});
  const [totalPolyTrade, setTotalPolyTrade] = useState({});
  const [loadingTreasury, setLoadingTreasury] = useState(true);
  const [allTreasuryData, setAllTreasuryData] = useState([]);
  const [ethTrans, setEthTrans] = useState(null);
  const [mapleBal, setMapleBal] = useState(null);
  const [brickkenBal, setBrickkenBal] = useState(null);
  const [devWalletBal, setDevWalletBal] = useState(null);
  const [totalDevWalletCondo, setTotalDevWalletCondo] = useState(null);
  let { setTotalTreasury } = useContext(TreasuryContext);
  const polytradeAddress = "0x692AC1e363ae34b6B489148152b12e2785a3d8d6";
  const condoPolygonTreasury = "0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310";
  const [allTreasuryTokenData, setAllTreasuryTokenData] = useState([]);

  const addressToCheck = "0x6404B20B5a8493c426b6efBE52809B206b26d393";
  const audioRef = useRef();
  const navigate = useNavigate();
  const [autoText] = useState(false);
  const [totalTreasuryBalance, setTotalTreasuryBalance] = useState(null);
  useEffect(() => {
    const fetchTreasuryData = async () => {
      try {
        setLoadingTreasury(true);
        const resp = await API.getAllTreasuryToken();
        setAllTreasuryData(resp.data?.totalBalance);
        setAllTreasuryTokenData(resp.data?.treasuryTokens);
      } catch (error) {
        console.error("Error fetching treasury data:", error);
      } finally {
        setLoadingTreasury(false);
      }
    };

    fetchTreasuryData();

    const intervalId = setInterval(fetchTreasuryData, 30000);

    return () => clearInterval(intervalId);
  }, []);
  const tokenAddressMap = {
    condo: condoAirdropAddress,
    eth: addressToCheck,
    trade: polyAddressToCheck,
    syrup: syrupContract,
    bkn: brickkenContract,
    eth2x: indexCoopContract,
    dev: devAddress,
  };
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">
        How is the total treasury calculated?
      </Popover.Header>
      <Popover.Body>
        {allTreasuryTokenData.map((token, index) => {
          const address = tokenAddressMap[token.symbol.toLowerCase()];
          const shortAddress = address
            ? ` from ${address.slice(0, 4)}...${address.slice(-4)}`
            : "";

          return (
            <div key={index}>
              {token.tokenName} ({token.symbol.toUpperCase()}): $
              {token.balanceUsd?.toLocaleString()}
              {shortAddress}
            </div>
          );
        })}
        <strong>Total: ${allTreasuryData?.toLocaleString()}</strong>
      </Popover.Body>
    </Popover>
  );
  useEffect(() => {
    const web3 = new Web3(
      "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
    );

    //Get condo balance
    const tokenContract = new web3.eth.Contract(condoABI, baseWalletAddress);
    async function getBalance() {
      try {
        const balance = await tokenContract.methods
          .balanceOf(addressToCheck)
          .call();
        const condoBalance = web3.utils.fromWei(balance, "ether");
        setEthBal(condoBalance);
        const exchangeRateResponse = await fetchCondo();
        const condoToUsdrates = exchangeRateResponse.current_price;

        setTotatCondo1(
          Number(parseFloat(condoBalance * condoToUsdrates).toFixed(2))
        );
        setCondoTrans(parseFloat(condoBalance * condoToUsdrates).toFixed(2));
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    }

    getBalance();

    web3.eth.getBalance(addressToCheck).then(async (balance) => {
      const condoBalance = web3.utils.fromWei(balance, "ether");
      const exchangeRateResponse = await fetchEth();

      const ethToUsdRates = exchangeRateResponse.current_price;

      setTotalBalance(
        Number(parseFloat(condoBalance * ethToUsdRates).toFixed(2))
      );
      setEthTrans(parseFloat(condoBalance * ethToUsdRates).toFixed(2));
    });
  }, []);
  useEffect(() => {
    const web3 = new Web3(
      "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
    );
    const tokenContract = new web3.eth.Contract(condoABI, baseWalletAddress);
    async function getBalance() {
      try {
        const balance = await tokenContract.methods
          .balanceOf(condoAirdropAddress)
          .call();
        const condoBalance = web3.utils.fromWei(balance, "ether");
        setCondoBal(condoBalance);
        const exchangeRateResponse = await fetchCondo();
        const condoToUsdrates = exchangeRateResponse.current_price;
        setCondoTrans2(parseFloat(condoBalance * condoToUsdrates).toFixed(2));
        setTotalCondo(
          Number(parseFloat(condoBalance * condoToUsdrates).toFixed(2))
        );
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    }

    getBalance();
  }, []);
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://polygon-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );
  //   async function getBalance() {
  //     try {
  //       // const bal = 15000000000000000000000n;
  //       // const condoBalance = web3.utils.fromWei(bal, "ether");
  //       const condoBalance = 25417;
  //       const exchangeRateResponse = await fetchAurusX();
  //       const condoToUsdrates = exchangeRateResponse.current_price;
  //       // setCondoTrans2(parseFloat(condoBalance * condoToUsdrates).toFixed(2));
  //       setPolyBal(
  //         Number(parseFloat(condoBalance * condoToUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }

  //   getBalance();
  // }, []);
  useEffect(() => {
    navigate("/home", { replace: true });
  }, [navigate]);
  useEffect(() => {
    const carMoving = document.getElementById("ondo-main-img");
    // fetch(
    //   "https://api.dexscreener.com/latest/dex/pairs/base/0xef9bccfba3a62e0a50d288a3031ca18f41f6c000"
    // )
    //   .then((response) => response.json())
    //   .then((data) => {
    //     const priceUsd = data.pairs[0].priceUsd;
    //     document.getElementById("price").textContent = priceUsd + "$";
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching the price:", error);
    //     document.getElementById("price").textContent = "Error fetching price";
    //   });

    const fetchPrice = async () => {
      // console.log("Fetching ");
      try {
        const response = await fetchCondo();
        // console.log("response:", response);
        const data = response.current_price;
        // console.log("API Dara:", data);
        if (data) {
          // const priceUsd = data.current_price;
          // console.log("Pricecondooo", priceUsd);
          document.getElementById("price").textContent = ` $ ${data}`;
        } else {
          // console.error("Invalid API response structure");
          document.getElementById("price").textContent = "Error fetching price";
        }
      } catch (error) {
        console.error("Error fetching the price:", error);
        document.getElementById("price").textContent = "Error fetching price";
      }
    };

    fetchPrice();

    let lastScrollPosition = window.pageYOffset;
    window.addEventListener("scroll", () => {
      const currentScrollPosition = window.pageYOffset;
      const scrollDistance =
        (currentScrollPosition - lastScrollPosition) * 0.02;
      let targetPosition = "50%";
      if (scrollDistance > 0) {
        targetPosition = "0";
      }
      carMoving.style.left = targetPosition;
      lastScrollPosition = currentScrollPosition;
    });

    const musicButton = document.getElementById("toggle-music-btn");
    const musicPlayer = document.getElementById("background-music");
    const movingCat = document.getElementById("moving-cat-gif");
    const stillCat = document.getElementById("still-cat-img");

    // if (window.location.reload) {
    //   musicPlayer.pause();
    //   musicButton.innerHTML = `<img src=${MuteBtn} alt="Pause music button" />`;
    //   movingCat.style.display = "none";
    //   stillCat.style.display = "block";
    // } else {
    // musicPlayer.play();
    movingCat.style.display = "block";
    stillCat.style.display = "none";
    // }
  }, []);

  useEffect(() => {
    const playAudio = async () => {
      try {
        await audioRef.current.play();
      } catch (error) {
        console.log("Autoplay prevented: ", error);
      }
    };

    playAudio();
  }, []);

  useEffect(() => {
    const text =
      "Condo the first memecoin based on real-world assets investing in real-world assets.";
    const textSpan = document.querySelector(".type-text");

    let index = 0;

    function type() {
      if (index < text.length) {
        textSpan.textContent += text.charAt(index);
        index++;
        setTimeout(type, 200);
      }
    }
    type();
  }, [autoText]);

  const copyContractAddress = (event) => {
    event.preventDefault();
    const contractAddressElement = document.getElementById("contractAddress");
    const tempInput = document.createElement("input");
    tempInput.value = contractAddressElement.innerText;
    document.body.appendChild(tempInput);

    tempInput.select();
    tempInput.setSelectionRange(0, 99999);

    document.execCommand("copy");
    document.body.removeChild(tempInput);
    // const copyIc = document.getElementById("copyIcon2");
    const copyIcon = document.getElementById("copyIcon");
    copyIcon.classList.remove("fa-copy");
    copyIcon.classList.add("fa-check");
    // copyIc.classList.remove("fa-copy");
    // copyIc.classList.add("fa-check");
    setTimeout(() => {
      copyIcon.classList.remove("fa-check");
      copyIcon.classList.add("fa-copy");
      // copyIc.classList.remove("fa-check");
      // copyIc.classList.add("fa-copy");
    }, 2000);
  };

  const audioHandler = () => {
    const musicButton = document.getElementById("toggle-music-btn");
    const musicPlayer = document.getElementById("background-music");
    const movingCat = document.getElementById("moving-cat-gif");
    const stillCat = document.getElementById("still-cat-img");
    // musicPlayer.play();
    // movingCat.style.display = "block";
    // stillCat.style.display = "none";

    // musicButton.innerHTML = `<img src=${MusicBtn} alt="Music button" />`;
    // musicButton.addEventListener("click", function () {
    if (musicPlayer.paused) {
      musicPlayer.play();
      musicButton.innerHTML = `<img src=${MusicBtn} svg" alt="Music button" />`;
      movingCat.style.display = "block";
      stillCat.style.display = "none";
    } else {
      musicPlayer.pause();
      musicButton.innerHTML = `<img src=${MuteBtn} alt="Pause music button" />`;
      movingCat.style.display = "none";
      stillCat.style.display = "block";
    }
    // });
  };

  // MapleABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://eth-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(mapleABI, syrupContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const mapleBalance = web3.utils.fromWei(balance, "ether");
  //       setMapleBal(mapleBalance);

  //       const exchangeRateResponse = await fetchCoinDetail("syrup"); // maple
  //       const mapleToUsdrates = exchangeRateResponse.current_price;

  //       setTotalMaple(
  //         Number(parseFloat(mapleBalance * mapleToUsdrates).toFixed(2))
  //       );
  //       // setMapleTrans(parseFloat(mapleBalance * mapleToUsdrates).toFixed(2));
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // BrickkenABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://bnb-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(brickkenABI, brickkenContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const brickkenBal = web3.utils.fromWei(balance, "ether");
  //       setBrickkenBal(brickkenBal);

  //       const exchangeRateResponse = await fetchCoinDetail("brickken");
  //       const brickkenToUsdrates = exchangeRateResponse.current_price;

  //       setTotalBrickken(
  //         Number(parseFloat(brickkenBal * brickkenToUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // indexCoopABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(
  //     indexCoopABI,
  //     indexCoopContract
  //   );
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const indexCoopBal = web3.utils.fromWei(balance, "ether");
  //       setIndexCoopBal(indexCoopBal);

  //       // const exchangeRateResponse = await fetchCoinDetail(
  //       //   "index-coop-ethereum-2x-index"
  //       // );
  //       // const indexCoopToUsdrates = exchangeRateResponse.current_price;

  //       const indexCoopToUsdrates = await fetchIndexCoopDetail();

  //       setTotalIndexCoop(
  //         Number(parseFloat(indexCoopBal * indexCoopToUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // devWalletCondoABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(devCondoABI, devCondoContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(devAddress)
  //         .call();

  //       const devWalletBal = web3.utils.fromWei(balance, "ether");
  //       setDevWalletBal(devWalletBal);

  //       const exchangeRateResponse = await fetchCondo();
  //       const devCondoToUsdrates = exchangeRateResponse.current_price;
  //       setTotalDevWalletCondo(
  //         Number(parseFloat(devWalletBal * devCondoToUsdrates).toFixed(2))
  //       );
  //       // console.log("totaldevWalletHomeCondo", totalDevWalletCondo);
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // USDCABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(usdcABI, usdcContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();
  //       // const indexCoopBal = web3.utils.fromWei(balance, "ether");
  //       // setIndexCoopBal(indexCoopBal);

  //       // const exchangeRateResponse = await fetchCoinDetail(
  //       //   "index-coop-ethereum-2x-index"
  //       // );
  //       // const indexCoopToUsdrates = exchangeRateResponse.current_price;

  //       // const indexCoopToUsdrates = await fetchIndexCoopDetail();

  //       // setTotalIndexCoop(
  //       //   Number(parseFloat(indexCoopBal * indexCoopToUsdrates).toFixed(2))
  //       // );
  //       const totalUSDC = Number(balance) / 1e6;
  //       // console.log("totalUSDCooooo", totalUSDC);

  //       setTotalUSDCBal(totalUSDC);
  //       const exchangeRateResponse = await fetchCoinDetail("usd-coin");
  //       const usdcToUsdrates = exchangeRateResponse.current_price;
  //       setTotalUSDC(Number(parseFloat(totalUSDC * usdcToUsdrates).toFixed(2)));
  //       // console.log("totalUSDCBal", totalUSDCBal);
  //       // console.log("totalUSDC", totalUSDC);
  //       // console.log("usdcToUsdrates", usdcToUsdrates);
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // polytradeABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://polygon-mainnet.g.alchemy.com/v2/AVp50h8nie8CF4LhvSjATb8_zEi3TLIE"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(polytradeABI, polytradeAddress);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(condoPolygonTreasury)
  //         .call();

  //       const totalPolyTrade = web3.utils.fromWei(balance, "ether");
  //       setPolyBal(totalPolyTrade);
  //       const polytradetoUsdrates = (await fetchCoinDetail("polytrade"))
  //         .current_price;
  //       setTotalPolyTrade(
  //         Number(parseFloat(totalPolyTrade * polytradetoUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);
  // useEffect(() => {
  //   if (
  //     totalBalance &&
  //     totalCondo1 &&
  //     polyBal &&
  //     totalMaple &&
  //     totalBrickken &&
  //     totalIndexCoop
  //   ) {
  //     setTotalTreasury(
  //       (
  //         totalBalance +
  //         totalCondo +
  //         totalCondo1 +
  //         polyBal +
  //         totalMaple +
  //         totalBrickken +
  //         totalIndexCoop +
  //         totalUSDC +
  //         totalPolyTrade
  //       ).toLocaleString()
  //     );
  //   }
  // }, [
  //   totalBalance,
  //   totalCondo,
  //   totalCondo1,
  //   polyBal,
  //   totalMaple,
  //   totalBrickken,
  // ]);
  // const popover = (
  //   <Popover id="popover-basic">
  //     <Popover.Header as="h3">
  //       How is the total treasury calculated?
  //     </Popover.Header>
  //     <Popover.Body>
  //       From{" "}
  //       {`${
  //         condoAirdropAddress.slice(0, 4) +
  //         "..." +
  //         condoAirdropAddress.slice(-4)
  //       }`}
  //       , {`${addressToCheck.slice(0, 4)}...${addressToCheck.slice(-4)}`},{" "}
  //       {`${polyAddressToCheck.slice(0, 4)}...${polyAddressToCheck.slice(-4)}`},{" "}
  //       {`${syrupContract.slice(0, 4)}...${syrupContract.slice(-4)}`},{" "}
  //       {`${brickkenContract.slice(0, 4)}...${brickkenContract.slice(-4)}`},{" "}
  //       {`${indexCoopContract.slice(0, 4)}...${indexCoopContract.slice(-4)}`}{" "}
  //       {`${polytradeAddress.slice(0, 4)}...${polytradeAddress.slice(-4)}`} and{" "}
  //       {`${usdcContract.slice(0, 4)}...${usdcContract.slice(-4)}`} we get{" "}
  //       {`${totalCondo}, ${totalCondo1}, ${totalBalance}, ${polyBal} , ${totalMaple}, ${totalBrickken}, ${totalIndexCoop}, ${totalPolyTrade} and ${totalUSDC}`}
  //       : Adding All
  //     </Popover.Body>
  //   </Popover>
  // );

  useEffect(() => {
    const fetchTreasuryData = async () => {
      try {
        const resp = await API.getAllTreasuryToken();
        setAllTreasuryData(resp.data.totalBalance);
      } catch (error) {
        console.error("Error fetching treasury data:", error);
      }
    };

    fetchTreasuryData();

    const intervalId = setInterval(fetchTreasuryData, 30000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <>
      <main className="body-main">
        <div className="banner-bg-section">
          <div className="container">
            <div className="banner-main-bg">
              <img
                alt="year-logo"
                width=""
                height=""
                className="year-logo m-auto"
                src={img2024}
                style={{ color: "transparent" }}
              />
              <div className="ondo-owner-div">
                <div className="ondo-condo-banner">
                  <img
                    alt="condo"
                    width="120"
                    height="30"
                    className="lmao-img-text"
                    src={BannerMiniCondo}
                    style={{ color: "transparent" }}
                  />

                  <img
                    id="ondo-main-img"
                    alt="banner-main-gif"
                    width=""
                    height=""
                    className="banner-gif"
                    srcSet="
                    https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png,
                    https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png;"
                    src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png"
                    style={{ color: "transparent" }}
                  />

                  <img
                    alt="banner-main-img"
                    width="83"
                    height="29"
                    className="text-banner-img"
                    src={BannerMiniOndo}
                    style={{
                      color: "transparent",
                      width: "83px",
                      height: "29px",
                    }}
                  />
                </div>
                <img
                  alt="title-img"
                  width=""
                  height=""
                  className="title-logo"
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722323307/condo_p8uxtk.svg"
                  style={{ color: "transparent" }}
                />
              </div>
              <span
                style={{ zIndex: "3", textAlign: "center" }}
                className="home-page-banner-cloud"
              >
                <h6
                  style={{ marginTop: "20px", zIndex: "5" }}
                  className="aclonica-regular "
                >
                  Price:
                  <span id="price">
                    <div className="spinner-grow" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="spinner-grow" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="spinner-grow" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </span>
                </h6>{" "}
                <div className="banner-cloud-img">
                  <div className="banner-img total-treasury-a total-treasury-width">
                    <h6 style={{ marginBottom: "0", color: "white" }}>
                      Total Treasury Value
                    </h6>
                    <h4 style={{ color: "white", whiteSpace: "noWrap" }}>
                      {loadingTreasury ? (
                        <div className="treasury-over-loading">
                          <div className="spinner-grow" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div className="spinner-grow" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div className="spinner-grow" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          ${allTreasuryData && allTreasuryData.toLocaleString()}
                          {/* {"$" +
                            (
                              Number(totalBalance) +
                              Number(totalCondo) +
                              Number(totalCondo1) +
                              Number(polyBal) +
                              Number(totalMaple) +
                              Number(totalBrickken) +
                              Number(totalIndexCoop) +
                              Number(totalUSDC) +
                              Number(totalPolyTrade)
                            ).toLocaleString()} */}
                          {/* <Link
                            title={`from ${condoAirdropAddress.slice(
                              0,
                              4
                            )}...${condoAirdropAddress.slice(
                              -4
                            )} and from ${addressToCheck.slice(
                              0,
                              4
                            )}...${addressToCheck.slice(
                              -4
                            )} we get ${condoTrans} ${ethBal} and ${ethTrans} : (Adding All three) `}
                            id="t-1"
                          >
                            <i
                              className="fa fa-info-circle fa-xs ms-2"
                              style={{ color: "white" }}
                            ></i>
                          </Link> */}
                          <OverlayTrigger
                            trigger="hover"
                            placement={isMobile ? "bottom" : "right"}
                            overlay={popover}
                          >
                            <i className="fa fa-info-circle fa-xs ms-2"></i>
                          </OverlayTrigger>
                        </>
                      )}
                    </h4>{" "}
                  </div>
                </div>
              </span>
              {/* <div className="dex_tool homedex_tool home-dex-toolImg">
                <a
                  href="https://dextools.io/app/en/base/pair-explorer/0xef9bccfba3a62e0a50d288a3031ca18f41f6c000?t=1712252416822"
                  target="_blank"
                >
                  <img src={DextoolWhite} alt="" />
                </a>
              </div>
              <div className="buy-btn-address">
                <div className="contract-add aclonica-regular">
                  <span>Contract Address:</span>
                  <p id="contractAddress" className="contract-address">
                    0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf
                  </p>
                </div>
                <div
                  className="copy-btn"
                  style={{ cursor: "pointer" }}
                  onClick={(event) => copyContractAddress(event)}
                >
                  <i id="copyIcon" className="fa fa-copy"></i>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="section-2 sec-2 container" id="about">
          <section className="aclonica-regular">
            <div className="section-2-main mx-auto">
              <div className="section-2-data">
                <p className="section-2-text">
                  Condo is based on Nathan, the founder of Ondo Finance and
                  inspired by BlackRock's RWA fund BUIDL, Condo is the first
                  memecoin based on Real-World Assets.
                  <br />
                  Ondo = Condo. As seen on{" "}
                  <a target="_blank" href="https://memecoinseason.io/p/condo">
                    memecoinseason.io
                  </a>
                </p>
                <img
                  id="moving-cat-gif"
                  alt="section-2-gif"
                  width="300"
                  height="100%"
                  className="moving-cat-gif"
                  srcSet={(MovingCat, MovingCat)}
                  src={MovingCat}
                  style={{ color: "transparent" }}
                />
                <img
                  id="still-cat-img"
                  alt="section-2-gif"
                  width="300"
                  height="100%"
                  className="moving-cat-gif"
                  srcSet={(StillCats, StillCats)}
                  src={StillCats}
                  style={{ color: "transparent" }}
                />
              </div>
              <div className="arrow-section-2-img-section">
                <img
                  alt="section-2-arrow"
                  width=""
                  height=""
                  className="arrow-section-2-img"
                  src={ArrowSection2}
                  style={{ color: "transparent" }}
                />
                <p className="text-section-3">
                  Condo implements a 3% tax on all transactions (buys and
                  sells), collecting funds in ETH. This tax fuels strategic
                  investments in top-tier Real-World Asset (RWA) protocols,
                  generating interest for the Condo treasury. By doing so, we
                  solidify Condo's role as a vital liquidity layer for the
                  Real-World Asset ecosystem. Our goal is to build one of the
                  largest and most robust treasuries in crypto.
                </p>
              </div>

              <div className="twitter-card">
                <img
                  alt="section-2-gif"
                  width="180"
                  height="100%"
                  className="fire-gif"
                  srcSet="
              
                  https://res.cloudinary.com/dbtsrjssc/image/upload/v1722323695/nathan_with_cat_2_rmugpq.png,
    ,
                  
                  https://res.cloudinary.com/dbtsrjssc/image/upload/v1722323695/nathan_with_cat_2_rmugpq.png,
    
                  "
                  src="
                  https://res.cloudinary.com/dbtsrjssc/image/upload/v1722323695/nathan_with_cat_2_rmugpq.png"
                  style={{ color: "transparent" }}
                />

                <div className="card-data">
                  <img
                    width="47"
                    height="47"
                    src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722323960/new_ranga_mucgbl.png"
                    style={{
                      color: "transparent",
                      borderRadius: "50%",
                      border: "1.5px solid black",
                    }}
                  />
                  <div className="inner-txt-twitter-card">
                    <div className="twitter-box">
                      <p className="twitter-box-profile aclonica-regular">
                        Ranga
                      </p>
                    </div>
                    <p className="twitter-box-username">@ranga_thegingercat</p>
                  </div>
                </div>
                <div className="tweet-twitter-box">
                  <div className="typing-text" data-testid="typing-text">
                    <span className="type-text"></span>
                    <span className="typing-cursor">|</span>
                  </div>
                </div>
                <img
                  alt=""
                  width="0"
                  height="0"
                  className="twitter-pixelated"
                  src={Pixelated}
                  style={{ color: "transparent" }}
                />
              </div>
            </div>
          </section>
        </div>
        <section className="section-3">
          <div className="container-fluid">
            <div className="section-3-main">
              <div className="blackrockimg-bg">
                <div className="container">
                  <div className="blackrock-handshake">
                    <img
                      src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722322699/nathan_and_lary_handshake_icispm.png"
                      alt="collab"
                      className="colab-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="section-4 aclonica-regular">
            <div className="container mx-auto sec-4">
              <div className="section-4-flex">
                <div className="coaster-img">
                  <img
                    src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722503840/gif-ezgif.com-optimize_t9vtij.gif"
                    alt="runnning-gif"
                    className="running-main-img"
                  />
                </div>
                <div className="section-4-text">
                  <p className="text-p-section-4 aclonica-regular">
                    Our mission is to invest in the future of real-world assets
                    (RWAs). <br />
                    <p className="text-p-section-4 aclonica-regular">
                      {" "}
                      Here's how it works:
                    </p>
                  </p>
                  <ul className="section-4-list">
                    <li className="">
                      Transaction Tax: A small fee (3%) is collected on both
                      purchases and sales of the condo memetoken.
                    </li>
                    <li className="">
                      Treasury Investment: Condo is a liquidity layer for the
                      entire RWA ecosystem. We're strategically investing our
                      funds into leading RWA protocol products, such as:
                      <br />
                      •Tokens
                      <br />
                      •Tbills
                      <br />
                      •Lending pools
                      <br />
                      •Presales <br />
                      In doing so, we're supporting top RWA projects and
                      generating interest for our treasury. Our goal is to grow
                      our treasury to 10s of millions of dollars.
                    </li>
                    <li className="">
                      Token Utility: While exploring all legal avenues, we don't
                      intend to distribute yield directly as it could
                      potentially classify CONDO as a security. As a utility and
                      governance token, we're actively researching ways to
                      involve holders in decisions. This could include voting
                      and rewards for participation , buy back and burn ,
                      deflationary tokenomics, rewards for long-term holders of
                      tokens, opportunities for holders of CONDO to get first
                      choice in RWA projects and more. We're committed to
                      exploring all viable options.
                    </li>
                  </ul>
                </div>
              </div>
              <img src={Coin} alt="coin" className="coin-img-bg" />
              <img src={Coin} alt="coin" className="coin-img2-bg" />
            </div>
          </div>
        </section>
        <section className="section-5">
          <div
            className="bg-how-to-buy mx-auto"
            backgroundImage="https://res.cloudinary.com/dbtsrjssc/image/upload/v1725969791/how-to-buy_hvk37o.png"
            style={{
              backgroundImage: `url(
                "https://res.cloudinary.com/dbtsrjssc/image/upload/v1725969791/how-to-buy_hvk37o.png"
              )`,
            }}
          ></div>
          <div className="container animation-how-to-buy">
            <section className="section-5-main">
              <div className="how-to-buy-btn">
                <div href="" className="how-to-buy-flex">
                  {/* <!-- <div className="buy-btn-inner">
                <p className="aclonica-regular buybtn-text">Buy $CONDO</p>
              </div> --> */}
                  <div
                    className="buy-btn-address"
                    style={{ fontWeight: "700" }}
                  >
                    <div className="contract-add aclonica-regular pt-4">
                      <span>Contract Address:</span>
                      <p id="contractAddress" className="contract-address">
                        0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf
                      </p>
                    </div>
                    <div
                      className="copy-btn"
                      style={{ cursor: "pointer" }}
                      onClick={(event) => copyContractAddress(event)}
                    >
                      <i id="copyIcon" className="fa fa-copy"></i>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <img
              src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722519642/james-selvog-walkyfinal2b-ezgif.com-optimize_1_sgvnmm.gif"
              alt="how-to-buy"
              className="laser-eyes-gif"
            />

            <div
              className="how-to-buy-frames"
              style={{ translate: "none", rotate: "none", scale: "none" }}
            >
              {/* <!-- <p href="" className="img-1-how">
            <img src="/images/how-to-buy/frame-1.png" alt="frame"
          /></p>
          <p href="" className="img-2-how">
            <img src="/images/how-to-buy/frame-2.png" alt="frame" />
          </p>
          <div className="img-3-how-div">
          <p href="" className="img-3-how"
            ><img src="/images/how-to-buy/how-to-buy-frame-3.png" alt="frame" />
            <div className="text-link aclonica-regular">
              <a href="https://www.bungee.exchange/" target="_blank">bungee</a>
            </div><div className="text-link-lifi aclonica-regular">
              <a href="https://jumper.exchange/?utm_campaign=link3&utm_medium=link3&utm_source=link3" target="_blank">lifi</a>
            </div>
          </p
          ></div>
          <p href="" className="img-4-how"
            ><img src="/images/how-to-buy/frame-4.png" alt="frame"
          /></p> --> */}
              <div className="img-1-how-div">
                <p href="" className="img-1-how">
                  <img
                    src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722591105/Group_27_1_fdvlpr.png"
                    alt="frame"
                  />
                  <div className="app-link-apple aclonica-regular">
                    <a
                      href="https://apps.apple.com/gb/app/strikex-defi-crypto-wallet/id6443517613"
                      target="_blank"
                    >
                      appstore
                    </a>
                  </div>
                  <div className="app-link-android aclonica-regular">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.tradestrike"
                      target="_blank"
                    >
                      playstore
                    </a>
                  </div>
                </p>
              </div>
              <p href="" className="img-2-how">
                <img
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722591105/Group_28_1_gncohq.png"
                  alt="frame"
                />
              </p>

              <p href="" className="img-3-how">
                <img
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722591105/Group_31_1_obbvdv.png"
                  alt="frame"
                />
              </p>

              <p href="" className="img-4-how">
                <img
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722591105/Group_30_1_eif7y7.png"
                  alt="frame"
                />
              </p>
            </div>
          </div>
          {/* <!-- <div className="buy-on-platforms aclonica-regular container">
      
        <div className="cta-btn-buys">
          <a href="https://www.bungee.exchange/" target="_blank" className="aclonica-regular buybtn-text">
          <div className="buy-btn-inner buy-btn-tokenomics">
         Buy on bungee
          </div></a>
          <a href="https://jumper.exchange/?utm_campaign=link3&utm_medium=link3&utm_source=link3" target="_blank" className="aclonica-regular buybtn-text">
          <div className="buy-btn-inner buy-btn-tokenomics">
           Buy on Lifi
          </div>
        </a>
          <a href="https://app.uniswap.org/explore/tokens/base/0x30d19fb77c3ee5cfa97f73d72c6a1e509fa06aef" target="_blank" className="aclonica-regular buybtn-text">
          <div className="buy-btn-inner buy-btn-tokenomics ">
           Buy on Uniswap
          </div>
        </a>
          <a href="https://dextools.io/app/en/base/pair-explorer/0xef9bccfba3a62e0a50d288a3031ca18f41f6c000?t=1712252416822" target="_blank" className="aclonica-regular buybtn-text">
          <div className="buy-btn-inner buy-btn-tokenomics ">
           Chart
          </div></a>
        </div>
        </div> --> */}
          <div id="dexscreener-embed">
            <iframe src="https://dexscreener.com/base/0xeF9bCCfBa3A62e0A50d288A3031cA18f41f6c000?embed=1&theme=dark"></iframe>
          </div>
        </section>

        <section>
          <div id="tokenomics" className="container">
            <div className="tokenomics-flex container mx-auto">
              <div className="left-tokenomics">
                <img
                  alt="tokenomics"
                  width="0"
                  height="0"
                  className="tokenomics-banner-img"
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722325899/tokenomics-banner_1_xyfoox.svg"
                  style={{ color: "transparent" }}
                />
                <img
                  alt="tokenomics-mobile"
                  width="0"
                  height="0"
                  className="tokenomics-banner-img-mobile"
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722325279/tokenomics-mobile-blue_uv9eih.svg"
                  style={{ color: "transparent" }}
                />
                <img
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722345964/cat-looking-front-back-gif-ezgif.com-optimize_mhszb6.gif"
                  alt="cry-cat"
                  className="cry-cat-gif"
                />
              </div>
              <div className="tokenomics-right aclonica-regular">
                <div className="tokenomics-first-row">
                  <div className="card-tokenomics">
                    <p className="card-toke-text-title aclonica-regular">
                      Total Supply
                    </p>
                    <p className="circ-text">10,000,000,000(10B) $CONDO</p>
                    <div className="dots-tokenomics"></div>
                    <div className="dots-tokenomics-2"></div>
                    <div className="dots-tokenomics-3"></div>
                    <div className="dots-tokenomics-4"></div>
                  </div>
                  <div className="card-tokenomics">
                    <p className="card-toke-text-title aclonica-regular">
                      Max Supply
                    </p>
                    <p className="circ-text">10,000,000,000(10B) $CONDO</p>
                    <div className="dots-tokenomics"></div>
                    <div className="dots-tokenomics-2"></div>
                    <div className="dots-tokenomics-3"></div>
                    <div className="dots-tokenomics-4"></div>
                  </div>
                  <div className="card-tokenomics">
                    <p className="card-toke-text-title aclonica-regular">
                      Circulating Supply
                    </p>
                    <p className="circ-text">10,000,000,000(10B) $CONDO</p>
                    <div className="dots-tokenomics"></div>
                    <div className="dots-tokenomics-2"></div>
                    <div className="dots-tokenomics-3"></div>
                    <div className="dots-tokenomics-4"></div>
                  </div>
                </div>
                <div className="card-tokenomics-full-width">
                  <p className="aclonica-regular card-toke-text-title">
                    Distribution
                  </p>
                  <div className="tokenomics-list-distribution">
                    <ul className="ul-distribution-list">
                      <li className="">40% Liquidity Pool</li>
                      <li className="">50% Presale</li>
                      <li className="">5% Airdrop</li>
                      <li className="">5% Future CEX Listing / Marketing </li>
                    </ul>
                    <img
                      src={Tea}
                      alt="tokenomics-tea"
                      className="tea-img-tokenomics"
                    />
                  </div>
                  <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
                <div className="card-tokenomics-full-width">
                  <p className="aclonica-regular card-toke-text-title">
                    $CONDO Information
                  </p>
                  <div className="tokenomics-list-distribution">
                    <ul className="ul-distribution-list">
                      {/* <!-- <li className="">
                    <div className="d-md-flex items-center gap-2">
                      <p className="">Contract Address:</p>
                      <div className="flex items-center gap-1">
                        <p id="contractAddress" className="contract-address">0xB0C2dsssco0xB0C2dssscoshcosiwehfcdncldscdDc6ashcosiwehfcdncldscdDc6a</p>
                      </div>
                      <div className="copy-btn" onclick="copyContractAddress(event)" style="cursor: pointer;">
                        <i id="copyIcon" className="fa fa-copy" ></i>
                    </div>
                    </div>
                  </li> --> */}
                      <li className="">
                        <div className="">
                          <p className="">Tax - 3% buy / 3% sell</p>
                        </div>
                      </li>
                      <li className="">
                        <div className="">
                          <p className="">No team allocation.</p>
                        </div>
                      </li>
                      <li className="">
                        <div className="">
                          <p className="">
                            Initial LP token burnt; Token contract renounced.
                          </p>
                        </div>
                      </li>
                      <li className="">
                        <div className="">
                          <p className="">ONDO = CONDO</p>
                        </div>
                      </li>
                    </ul>
                    <img
                      src={Fan}
                      alt="tokenomics-fan"
                      className="tokenomics-fan-img"
                    />
                  </div>
                  <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer>
          <hr
            style={{
              color: "#76c7fe",
              height: "3px",
              backgroundColor: "#76c7fe",
            }}
          />
          <div className="footer-desc aclonica-regular">
            <p>
              Nathan or ONDO Finance or Blackrock is not associated with $CONDO
              or its creation. This token is paying homage to a meme we all love
              and recognize. <br />
              $CONDO is a meme coin with no intrinsic value or utility.
            </p>
          </div>
          {/* <!-- <div className="footer-flex container">
        <p>CZ is not associated with $CONDO or its creation. This token is paying homage to a meme we all love and recognize. <br>$CONDO is a meme coin with no intrinsic value or utility.</p>
      </div> --> */}
          <div className="footer-flex container">
            <div className="logo-footer" style={{ cursor: "pointer" }}>
              <a href="http://condobase.xyz/" target="_blank">
                <img
                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png"
                  alt="logo-img"
                  width="70"
                  height="70"
                />
              </a>
            </div>
            <div className="footer-center-section aclonica-regular">
              <div
                className="social-links-footer"
                style={{ cursor: "pointer" }}
              >
                <a
                  href="https://x.com/Condo_Base?t=pDe6ikBbmBG1q4lVTt1Ckw&s=09"
                  target="_blank"
                >
                  {" "}
                  <i className="fa-brands fa-x-twitter fa-lg"></i>
                </a>
                <a href="https://t.me/Condo_Official" target="_blank">
                  {" "}
                  <i className="fa-brands fa-telegram ms-3 fa-lg"></i>
                </a>
                <a
                  href="https://medium.com/@condobasechain/condo-the-memetoken-investing-in-real-world-assets-33a17b51bac9"
                  target="_blank"
                >
                  {" "}
                  <i className="fa-brands fa-medium ms-3 fa-lg"></i>
                </a>
                <a
                  href="https://www.geckoterminal.com/base/pools/0xef9bccfba3a62e0a50d288a3031ca18f41f6c000"
                  target="_blank"
                >
                  {" "}
                  <img
                    src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1712927079/geckoterminal_icon_liduyt.png"
                    width="25"
                    alt=""
                    className="ms-3"
                  />
                </a>
              </div>
            </div>

            <div
              className="search-btns aclonica-regular"
              role="search"
              style={{ cursor: "pointer" }}
            >
              {" "}
              <a
                href="https://app.uniswap.org/explore/tokens/base/0x30d19fb77c3ee5cfa97f73d72c6a1e509fa06aef
        "
                target="_blank"
              >
                <button className="btn nav-btns-bg" style={{ color: "white" }}>
                  Buy
                </button>
              </a>
            </div>
          </div>
          <div className="copyright-footer aclonica-regular">
            {" "}
            <div className="contact-mail aclonica-regular">
              <i className="fa fa-envelope"></i> CondoBaseChain@gmail.com{" "}
            </div>
            <i className="fa fa-copyright"></i> All Rights Reserved CONDO 2024
          </div>
        </footer>
      </main>
      <div className="audio-btns">
        <audio
          ref={audioRef}
          id="background-music"
          preload="auto"
          loop
          autoPlay
        >
          <source src={Bumbershoot} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
        {/* <iframe src="/images/audio/Bumbershoot.mp3" allow="autoplay" frameborder="0"></iframe> */}
        <button id="toggle-music-btn" onClick={audioHandler}>
          <img src={MusicBtn} alt="Music button" />
          {/* <img src="/images/mute-btn.svg" alt="Music button" />*/}
        </button>
      </div>
    </>
  );
};

export default Home;
